import React, {Fragment} from 'react';
import WalletContext from './index';
import type {WalletContextType, WalletProviderProps} from './WalletContext.types';
import {H6} from "../../../../AbstractElements";
import axiosConfig from "../../../../Config/axios";
import {getApplicationRoute} from "../../../../Route/RouteIndex";

const WalletProvider: React.FC<WalletProviderProps> = ({children}) => {
    const getOwerTypeColor = (ownerType: string): string => {
        switch (ownerType.toLowerCase()) {
            case 'collector':
                return 'primary';
            case 'participant':
                return 'success';
            case 'user':
                return 'warning';
            case 'board':
                return 'info';
            default:
                return 'secondary';
        }
    };

    const getFormattedAmount = (transactionAmount: number, type: string, nature: 1 | 0) => {
        const amount = nature
            ? transactionAmount
            : 0 - transactionAmount;

        return <span className={`font-${nature ? 'success' : 'danger'}`}>{type === 'wallet-type-points'
            ? <span>{amount}<span
                className={'m-l-10'}>POINTS</span></span> : (amount)?.toLocaleString(
                'en-LK',
                {
                    style: 'currency',
                    currency: 'LKR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }
            )
        } </span>
    };

    const getTransactionInfo = (walletTransaction: any): React.ReactNode => {
        return (
            <Fragment>
                <div>
                    <span
                        className={`badge badge-light-${getOwerTypeColor(walletTransaction.wallet_owner_type)} m-r-20`}
                    >
                    {walletTransaction.wallet_owner_type}
                </span>
                    {walletTransaction.wallet_owner_name}
                </div>
                <div>
                    <span
                        className={`badge badge-light-${walletTransaction.wallet_type_key === 'wallet-type-points' ? 'primary' : 'success'} m-r-20`}
                    >
                    {walletTransaction.wallet_type}
                </span>
                    {getFormattedAmount(walletTransaction.amount, walletTransaction?.wallet_type_key, walletTransaction?.transaction_nature)}
                </div>
            </Fragment>
        );
    };

    const getWalletInformation = (wallet: any): React.ReactNode => {
        return (
            <table width={'100%'}>
                <tbody>
                <tr>
                    <td>
                        <div className='d-flex align-items-center gap-2'>
                            <div>
                                <span
                                    className={`badge badge-light-${wallet.wallet_type_key === 'wallet-type-points' ? 'primary' : 'success'} m-r-20`}>{wallet.wallet_type}</span>
                            </div>
                            <div className={`font-primary`}>
                                {getFormattedAmount(wallet?.current_balance, wallet?.wallet_type_key, 1)}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>
                            <H6 attrH6={{className: 'f-14 mb-1'}}>{wallet?.last_transaction.description}</H6>
                        </div>
                        <div className='text-end'>
                            <H6 attrH6={{className: 'f-14 f-w-400 mb-1'}}>
                                {getFormattedAmount ? getFormattedAmount(wallet?.last_transaction.amount, wallet?.last_transaction?.wallet_type_key, wallet?.last_transaction?.transaction_nature) : 0}
                            </H6>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        )
    };

    const createPendingWallets = (relationKey: string, relationId: string | number, callback?: () => void, errorCallback?: (error: any) => void) => {
        axiosConfig
            .post(`${getApplicationRoute('wallet')}/create/pending-wallets`, {
                relation_key: relationKey,
                relation_id: relationId
            })
            .then((response: any) => {
                if (response?.data?.data && callback) {
                    callback();
                }
            })
            .catch((exception: any) => {
                if (errorCallback) {
                    errorCallback(exception);
                }
            });
    };

    const contextValue: WalletContextType = {
        getTransactionInfo,
        getOwerTypeColor,
        getFormattedAmount,
        getWalletInformation,
        createPendingWallets,
    };

    return <WalletContext.Provider value={contextValue}>{children}</WalletContext.Provider>;
};

export default WalletProvider;

